import { render, staticRenderFns } from "./PersonalLoanSummary.vue?vue&type=template&id=197e4e43"
import script from "./PersonalLoanSummary.vue?vue&type=script&lang=js"
export * from "./PersonalLoanSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports